import { Instagram, MapPin, Phone } from "lucide-react";
import { Brand } from "./Navbar";
import { WA_NUMBER } from "../data";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container f-grid">
        <div className="f-brand">
          <Brand light />
          <p>
            Bersih kinclong, rumah happy.
            <br />
            Karena Anda layak punya waktu untuk hal yang lebih penting.
          </p>
        </div>
        <div className="f-links">
          <div>
            <strong>Jelajahi</strong>
            <a href="#layanan">Layanan</a>
            <a href="#galeri">Galeri</a>
            <a href="#harga">Harga</a>
            <a href="#faq">FAQ</a>
          </div>
          <div>
            <strong>Hubungi kami</strong>
            <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noreferrer">
              <Phone size={13} /> 0859-4516-9127
            </a>
            <a href="#beranda">
              <MapPin size={13} /> Jakarta &amp; sekitarnya
            </a>
            <a href="#beranda">
              <Instagram size={13} /> @antarcleaning
            </a>
          </div>
        </div>
      </div>
      <div className="f-bottom">
        <div className="container f-bottom-inner">
          <span>© 2026 antarcleaning. All rights reserved.</span>
          <span>Made with care for cleaner homes.</span>
        </div>
      </div>
    </footer>
  );
}
